<template>
  <div
    :class="{
      notification: true,
      loading: timer,
      fail: notification && notification.type === 'fail',
      success: notification && notification.type === 'success'
    }"
  >
    <div class="notification--inner">
      <p v-text="notification.text"></p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'Notification',
  props: {
    notification: {
      type: Object
    }
  },
  data() {
    return {
      timer: null
    };
  },
  methods: {
    ...mapActions('auth', ['removeNotification']),
    triggerClose() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.removeNotification(this.notification);
    }
  },
  mounted() {
    this.timer = setTimeout(() => {
      this.triggerClose();
    }, 5000);
  }
};
</script>

<style scoped>
.notification {
  z-index: 5;
  position: relative;
  width: 200px;
  padding: 6px 16px;
  margin: 10px 0;
  margin-bottom: 0;
  font-size: 0.9rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  border-radius: 4px;
  background: white;
  color: #26007b;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: appear 5s forwards;
}

.notification--inner {
  display: flex;
  justify-content: center;
  align-items: center;
}

.fa {
  position: relative;
  width: 100%;
  text-align: center;
}
.success {
  background: linear-gradient(0deg, #2b8e3b, #427d36);
  color: white;
}
.fail {
  background: linear-gradient(0deg, #d7290f, #af2c23);
  color: white;
}
button {
  border: none;
}

@keyframes appear {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes loading {
  100% {
    transform: translate(0);
  }
}
</style>
